export default __webpack_public_path__ + "i18n/translations/translation-id.ba57060a.json";